import { isNode } from 'detect-node-es';
export var env = {
    isNode: isNode,
    forceCache: false,
};
